import React from "react";
export var ThemeModeContext = React.createContext({
    mode: "light",
    toggleMode: function () { return undefined; },
});
export var useThemeMode = function () { return React.useContext(ThemeModeContext); };
